module.exports = __webpack_public_path__ + "img/home_bl.605b9420.svg";